import { IWebsiteSettings } from '@/interfaces/_auto/api';

export default function getGlobalSettings(): IWebsiteSettings {
  const configs = (window as any)?.globalConfiguration;
  return configs as IWebsiteSettings;
}
